import { Column, Entity, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";

@Entity('attendance')
export class AttendanceEntity {

    @PrimaryGeneratedColumn('increment', {
        name: 'attendace_id'
    })
    attendaceId: number;

    @Column('int', {
        nullable: true,
        name: 'attendace_log_id'
    })
    attendanceLogId: number

    @Column('int', {
        nullable: false,
        name: 'employee_id'
    })
    employeeId: number;

    @Column('date', {
        name: 'date'
    })
    date: string;

    @Column('varchar', {
        nullable: false,
        length: 10,
        name: 'log_date'
    })
    logDate: Date;

    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'employee_code'
    })
    employeeCode: string;

    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'employee_name'
    })
    employeeName: string;

    @Column({
        name: 'download_date'
    })
    downloadDate: string;

    @Column({
        name: 'in_time'
    })
    inTime: Date;

    @Column({
        name: 'out_time'
    })
    outTime: Date;

    @Column("varchar", {
        nullable: false,
        default: 'A',
        name: 'present_status'
    })
    presentStatus: string;

    @Column("varchar", {
        nullable: true,
        name: 'leave_status'
    })
    leaveStatus: string;

    @Column("varchar", {
        nullable: true,
        name: 'reason'
    })
    reason: string;

    @Column("boolean", {
        default: false,
        name: 'hr_status'
    })
    hrStatus: boolean;

    @Column({
        name: 'verify_mode'
    })
    verifyMode: string;

    @Column("varchar", {
        nullable: true,
        name: "rf_code"
    })
    rfCode: string;

    @Column("int", {
        nullable: false,
        name: "department_id"
    })
    departmentId: number;

    @Column("varchar", {
        nullable: false,
        name: "department_code"
    })
    departmentCode: string;

    @Column("varchar", {
        nullable: true,
        name: "designation"
    })
    designation: string;

    @Column("varchar", {
        nullable: false,
        name: "shift_group"
    })
    shiftGroup: string;

    @Column("int", {
        name: 'unit_id'
    })
    unitId: number;

    @Column('tinyint', {
        nullable: false,
        name: "day"
    })
    day: number;

    @Column('tinyint', {
        nullable: false,
        name: "month"
    })
    month: number;

    @Column('smallint', {
        nullable: false,
        name: "year"
    })
    year: number;

    @Column('varchar', {
        nullable: false,
        length: 10,
        name: 'shift'
    })
    shift: string;

    @Column('int', {
        default: 0,
        name: 'flag'
    })
    flag: number;

    @Column('varchar', {
        nullable: true,
        name: 'team_code'
    })
    teamCode: string;

    @Column("varchar", {
        nullable: true,
        name: "device_code"
    })
    deviceCode: string;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean | null;

    @Column("varchar", {
        nullable: false,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @CreateDateColumn({
        name: "created_at",
        type: 'datetime'
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

}